import { render, staticRenderFns } from "./LogDispatch.vue?vue&type=template&id=d1054170&scoped=true"
import script from "./LogDispatch.vue?vue&type=script&lang=js"
export * from "./LogDispatch.vue?vue&type=script&lang=js"
import style0 from "./LogDispatch.vue?vue&type=style&index=0&id=d1054170&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1054170",
  null
  
)

export default component.exports